import { editor, KeyCode, KeyMod, languages, MarkerSeverity } from 'monaco-editor';

import { routes } from '../routes';

import { granetLanguageConfig } from './languages/granet/config';
import { granetSyntaxDefinition } from './languages/granet/syntax';

languages.register({ id: 'granet' });
languages.setMonarchTokensProvider('granet', granetSyntaxDefinition);
languages.setLanguageConfiguration('granet', granetLanguageConfig);

window.MonacoEnvironment = {
    getWorkerUrl: () => routes.app.assets('editor.worker.js', __appConfig.app.urlRoot),
};

export { languages, editor, MarkerSeverity, KeyMod, KeyCode };
